import { DateTime } from "luxon";
import { useCallback } from "react";

const isShift3 = (shiftName: string): boolean => {
  return shiftName.startsWith("3");
};

export const useShiftDateMatcher = () => {
  const getAllowedDatesMatcher = useCallback(
    (shiftDate: Date, shiftName: string) => {
      const isThirdShift = isShift3(shiftName);
      const shiftDateTime = DateTime.fromJSDate(shiftDate).startOf("day");
      const nextDay = shiftDateTime.plus({ days: 1 }).startOf("day");

      const lastAllowedDay = isThirdShift
        ? nextDay.toJSDate()
        : shiftDateTime.toJSDate();

      return [{ before: shiftDateTime.toJSDate() }, { after: lastAllowedDay }];
    },
    [],
  );

  return {
    getAllowedDatesMatcher,
  };
};
